<template>
  <v-card class="mt-4" dark color="primary">
    <v-layout row wrap>
      <v-flex xs10 md8 offset-xs1 offset-md2>
        <v-card-title primary-title class="layout justify-center">
          <h1 class="aling-center font-weight-light">
            ¡Ahorra tiempo y dinero!
          </h1>
        </v-card-title>
        <v-card-text>
          <p color="grey darken-1" class="title">
            Subscribete y te enviaremos las mejores ofertas
          </p>
        </v-card-text>
        <v-card-text>
          <v-text-field light label="E-mail" solo></v-text-field>
          <v-checkbox
            label="¡Envíame un enlace para descargar la app de Telemon GRATIS!"
            color="gray"
            hide-details
          ></v-checkbox>
          <v-btn outlined large color="white">Suscríbirme</v-btn>
        </v-card-text>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
export default {
  name: "Subscribe-Container",
};
</script>
